import "./css/Select.css";
import React from "react";
import { SelectProvider, useOption, useSelect } from "@mui/base";

// COMPONENTS
import { ButtonPrimary } from "../Buttons";

// ICONS
import { BsCheckLg } from "react-icons/bs";

function renderSelectedValue(value, options) {
  const selectedOption = options.find((option) => option.value === value);

  return selectedOption ? selectedOption.render : null;
}

function Option(props) {
  const { children, value, className, disabled = false } = props;
  const { getRootProps, highlighted } = useOption({
    value,
    disabled,
    label: children,
  });

  return (
    <li
      {...getRootProps()}
      className={`option ${highlighted && "highlighted"}`}
    >
      {children}
      <BsCheckLg className="icon" />
    </li>
  );
}

export default function Select(props) {
  const {
    options,
    placeholder,
    onChange,
    btnStyle,
    optionStyle,
    id,
    btnClassName,
  } = props;
  const boxRef = React.useRef(null);
  const [listboxVisible, setListboxVisible] = React.useState(false);

  const { getButtonProps, getListboxProps, contextValue, value } = useSelect({
    boxRef,
    open: listboxVisible,
    onOpenChange: setListboxVisible,
    onChange,
    value: props.value,
  });

  React.useEffect(() => {
    if (listboxVisible) {
      boxRef.current?.focus();
    }
  }, [listboxVisible]);

  return (
    <div className="select-wrapper">
      <ButtonPrimary
        {...getButtonProps()}
        name={
          renderSelectedValue(value, options) || (
            <span className="placeholder">{placeholder ?? " "}</span>
          )
        }
        select
        style={{
          ...btnStyle,
        }}
        className={btnClassName}
      />

      <ul
        {...getListboxProps()}
        aria-hidden={!listboxVisible}
        className={`option-group ${!listboxVisible && "hidden"}`}
        style={{ ...optionStyle }}
        id={id}
      >
        <SelectProvider value={contextValue}>
          {options.map((option) => {
            return (
              <Option key={option.value} value={option.value}>
                {option.label}
              </Option>
            );
          })}
        </SelectProvider>
      </ul>
    </div>
  );
}
